/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, useCallback } from 'react';

interface MonthlyDetailsContextValue {
  isOpen: boolean;
  initialYear?: number;
  initialMonth?: number; // 0-based
  openMonthlyDetails: (params?: { year?: number; month?: number }) => void;
  closeMonthlyDetails: () => void;
}

const MonthlyDetailsDialogContext = createContext<MonthlyDetailsContextValue | undefined>(
  undefined,
);

export const useMonthlyDetailsDialog = (): MonthlyDetailsContextValue => {
  const ctx = useContext(MonthlyDetailsDialogContext);
  if (!ctx) {
    throw new Error('useMonthlyDetailsDialog must be used within MonthlyDetailsDialogProvider');
  }
  return ctx;
};

export const MonthlyDetailsDialogProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [initialYear, setInitialYear] = useState<number | undefined>(undefined);
  const [initialMonth, setInitialMonth] = useState<number | undefined>(undefined);

  const openMonthlyDetails = useCallback((params?: { year?: number; month?: number }) => {
    setInitialYear(params?.year);
    setInitialMonth(params?.month);
    setIsOpen(true);
  }, []);

  const closeMonthlyDetails = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <MonthlyDetailsDialogContext.Provider
      value={{ isOpen, initialYear, initialMonth, openMonthlyDetails, closeMonthlyDetails }}
    >
      {children}
    </MonthlyDetailsDialogContext.Provider>
  );
};
